import SkillzStyle, {addColors} from 'SkillzStyle';
import {
  StyleSheet, ViewStyle,
} from 'react-native';
import Sizes from 'Sizes';

const {
  fontBold,
  fontSecondary,
} = SkillzStyle.fullStyles;

export type CircleProgressLevelColors={
  backgroundColor:string;
  tintColor:string;
  innerCircleBorderColor:string;
}

export const DEFAULT_SIZE = Sizes.select({smallPhone: 72, largePhone: 96, tablet: 120});
const PROGRESS_BAR_WIDTH = 6;
const SIZE_INNER_CIRCLE = 0.94;
const SIZE_LEVEL_CIRCLE = 0.375;
const Y_OFFSET = 0.22;
const SIZE_LEVEL_TEXT = 0.6;

// Precalculate all the color math
export const TINT_COLOR = SkillzStyle.fullStyles.tabHighlightColor.color;
// eslint-disable-next-line no-magic-numbers
export const BACKGROUND_COLOR = addColors(SkillzStyle.convertToOpacity(SkillzStyle.fullStyles.viewPrimaryColor.backgroundColor, 0.75), 'rgba(0,0,0,0.6)');
export const INNER_CIRCLE_BORDER_COLOR = addColors(BACKGROUND_COLOR, 'rgba(0,0,0,0.5)');

export const styleOfProgressCircle = (size:number, customColors:CircleProgressLevelColors) => {
  const backgroundColorInnerCircle = customColors.backgroundColor;
  const innerCircleBorderColor = customColors.innerCircleBorderColor;
  const sizeOfInnerCircle = (size - (PROGRESS_BAR_WIDTH * 2)) * SIZE_INNER_CIRCLE;
  const borderRadiusOfInnerCircle = size / 2;
  return {
    backgroundColor: backgroundColorInnerCircle,
    width: sizeOfInnerCircle,
    height: sizeOfInnerCircle,
    borderRadius: borderRadiusOfInnerCircle,
    borderWidth: 2,
    borderColor: innerCircleBorderColor,
  };
};

export const styleOfLevelCircleAnimatableView = (size:number) => {
  const sizeOfCircle = size * SIZE_LEVEL_CIRCLE;
  const yOffset = -(size * Y_OFFSET);
  return {
    width: sizeOfCircle,
    height: sizeOfCircle,
    top: yOffset,
    paddingTop: -yOffset,
    marginBottom: yOffset,
  };
};

export const styleOfLevelCircle = (size:number, isPlaceholder:boolean, customColors:CircleProgressLevelColors) => {
  const sizeOfCircle = size * SIZE_LEVEL_CIRCLE;
  const borderRadiusOfInnerCircle = size / 2;
  const yOffset = -(size * Y_OFFSET);
  const color = isPlaceholder ? customColors.backgroundColor : customColors.tintColor;
  return {
    width: sizeOfCircle,
    height: sizeOfCircle,
    borderRadius: borderRadiusOfInnerCircle,
    top: yOffset,
    marginBottom: yOffset,
    backgroundColor: color,
  };
};

export const overrideStyleOfInnerCircle = (backgroundColor?: string, borderColor?: string): ViewStyle => {
  const backgroundColorStyle = backgroundColor ? {backgroundColor} : {};
  const borderColorStyle = borderColor ? {borderColor} : {};
  return {
    ...backgroundColorStyle,
    ...borderColorStyle,
  };
};

export const styleOfLevelCircleLabel = (size:number) => {
  const sizeOfCircle = size * SIZE_LEVEL_CIRCLE;
  const color = SkillzStyle.fullStyles.btnTextColorOne.color;
  return {
    width: sizeOfCircle * SIZE_LEVEL_TEXT,
    height: sizeOfCircle * SIZE_LEVEL_TEXT,
    fontSize: (sizeOfCircle * SIZE_LEVEL_TEXT) - 2,
    color: color,
    backgroundColor: 'transparent',
  };
};

export const styleOfLevelCircleImage = (size:number, imageMultiplicator:number = 1) => {
  const sizeOfImage = size * SIZE_LEVEL_CIRCLE * imageMultiplicator;
  return {height: sizeOfImage, width: sizeOfImage};
};

export default StyleSheet.create({
  mainContainer: {
    alignItems: 'center',
  },

  innerCircle: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  iconImg: {
    borderRadius: 4,
    paddingBottom: 2,
  },

  levelCircle: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  currentLevelText: {
    ...fontBold,
    ...fontSecondary,
    margin: 8,
    textAlign: 'center',
    textAlignVertical: 'center',
    backgroundColor: 'transparent',
  },
});
